package pl.decks.chartjs.radar.options.plugins

import pl.decks.chartjs.color.ChartColor
import pl.decks.chartjs.jsConstructors.jso
import pl.decks.chartjs.model.ChartJSOption
import pl.decks.chartjs.model.JSScriptable
import pl.decks.chartjs.radar.options.FontOptions

data class LegendLabelOptions(
    val color: JSScriptable<ChartColor>? = null,
    val font: FontOptions? = null,
    val boxWidth: Int? = null,
    val boxHeight: Int? = null,
    val padding: Int? = null,
    val usePointStyle: Boolean = false,
    val pointStyleWidth: Float? = null,
) : ChartJSOption {
    override fun toChartJs(): dynamic = jso {
        if (color != null) this.color = color.toChartJs { it.toChartJs() }
        if (font != null) this.font = font.toChartJs()
        if (boxWidth != null) this.boxWidth = boxWidth.asDynamic()
        if (boxHeight != null) this.boxHeight = boxHeight.asDynamic()
        if (padding != null) this.padding = padding.asDynamic()
        this.usePointStyle = usePointStyle.asDynamic()
        if (pointStyleWidth != null) this.pointStyleWidth = pointStyleWidth.asDynamic()
    }
}
